import { gql } from "@apollo/client";

export const SAVERATING = gql`
  mutation saveRating(
    $book_id: ID!
    $rating: Int!
    $message: String
    $is_author: Boolean
  ) {
    saveRating(
      book_id: $book_id
      rating: $rating
      message: $message
      is_author: $is_author
    )
  }
`;
